export default __webpack_public_path__ + "static/media/36I-114277_-20863_0.70454796.jpg";